import { Button, ButtonGroup, Link, Card, Grid, Paper, Table, TableContainer } from '@mui/material';
import React, { useState } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import { useCreateSKUMutation, useGetProductsForFamilyQuery } from '../features/products/productSlice';
import ProductCard, { ProductAddNewCard } from '../components/ProductCard';
import ProductAutocomplete from '../components/ProductAutocomplete';
import Loading from '../components/Loading';
import { ProductDetailsCard } from './ProductView';
import { Box, Stack } from '@mui/system';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewArrayIcon from '@mui/icons-material/ViewArray';
import EditIcon from '@mui/icons-material/Edit';
import {ProductRow, ProductHeader } from '../components/ProductRow';

const ProductsBrowser = () => {
    let params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    let family_id = params.familyId;
    const [searchName, setSearchName] = useState(searchParams.get("q") ?? "");
    const [mode, setMode] = useState(searchParams.get("viewMode") ?? "");
    const navigate = useNavigate();
    const [editing, setEditing] = useState(false);

    const {data: products, error, isLoading } = useGetProductsForFamilyQuery({family_id})
    const [createSKU] = useCreateSKUMutation();

    if (isLoading) {
      return <Loading />;
    }
    if (error) {
      return <div>Error: {error}</div>
    }

    const makeLinkToProduct = (product) => {
      return `/products/${product.product_family}/${product.id}${editing?"/edit":""}`
    }

    function handleSearch(value) {
      setSearchName(value.toLowerCase());
      var sparams = searchParams;
      sparams.set("q", value);
      setSearchParams(sparams);
    }

    let filtered_products = products.objects.filter((p) => {if(searchName === "") return true; return p.name.toLowerCase().includes(searchName) || p.code.toLowerCase().includes(searchName);})

    if (searchName !== "") {
      // if just one result, redirect
      if (filtered_products.length === 1) {
        navigate(`/products/${family_id}/${filtered_products[0].id}` + editing ? "/edit" : "")
      }
    }

    const addProduct = (name) => {
      let new_sku = {
        name: name,
        code: name.replace(" ", ""),
        product_family: family_id,
        item_type: "single"
      };
      createSKU({data: new_sku});
    }

    const getProductView = (view_mode) => {
      switch(view_mode) {
        case "details":
          return <Grid container spacing={2} sx={{marginTop: 2}}>
            {filtered_products.filter((p) => {return p.item_type==="single"}).map((product, i) => <Grid item key={product.id} component={RouterLink} to={makeLinkToProduct(product)}>
              <Card sx={{padding: 1, width: 320}}><ProductDetailsCard product={product} /></Card>
            </Grid>)}
            <Grid item key="add_new"><ProductAddNewCard onAddProduct={addProduct}/></Grid>
          </Grid>
        case "list":
          return <TableContainer component={Paper}>
              <Table>
                <ProductHeader />
                {
                  filtered_products.map((product, i) => <ProductRow product={product} editing={editing} />)
                }
              </Table>
            </TableContainer>
        default:
          return <Grid container spacing={2} sx={{marginTop: 2}}>
            {
              filtered_products.map((product, i) => <Grid item key={product.id} component={RouterLink} to={makeLinkToProduct(product)}><ProductCard product={product} /></Grid>)
            }
            <Grid item key="add_new"><ProductAddNewCard onAddProduct={addProduct}/></Grid>
          </Grid>
        }
    }

    function switchTo(mode) {
      setMode(mode);
      var sparams = searchParams;
      sparams.set("viewMode", mode);
      setSearchParams(sparams);
    }

    return (
      <>
        <Stack direction="row" justifyContent="space-between">
        <ButtonGroup sx={{marginTop:2}}>
          <Button sx={{marginRight: 1}} component={RouterLink} to={`/products`} variant="contained">Back</Button>
          <Button variant={editing ? "contained" : "outlined"} onClick={(event) => {setEditing(!editing);}}><EditIcon /></Button>
        </ButtonGroup>
        <Box sx={{width: "1"}}/>
        <Button onClick={() => {switchTo("");}}><ViewModuleIcon /></Button>
        <Button onClick={() => {switchTo("details");}}><ViewArrayIcon /></Button>
        <Button onClick={() => {switchTo("list");}}><ViewListIcon /></Button>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
        <ProductAutocomplete products={products.objects} searchHandler={handleSearch}/>
        {searchName !== "" ? <Button variant="outlined" onClick={() => {handleSearch("")}}>{searchName}</Button> : <></>}
        </Stack>
        {getProductView(mode)}
      </>
    );
}

export default ProductsBrowser;
